import { styled } from 'styled-components';

export const PostSearchSideFacetFilterHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PostSearchSideFacetFilterRelatedHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 12px -2px 0;
`;

export const PillHolder = styled.div`
  max-width: 50%;
  padding: 4px 2px;
`;
